import { useEffect } from 'react';
import { useDateStore } from "./store";

const useResetFormWithWorkingDayChange = (defaultValuesFn, reset, conditions) => {
  const date = useDateStore(state => state.getDayJSDate())
  //Reset form on tank or date change
  return useEffect(() => reset(() => {
    reset(defaultValuesFn())
  }), conditions.concat(date.format("DD/MM/YY")))
};

export default useResetFormWithWorkingDayChange;